export default "__VITE_ASSET__a4edcef5__"